import { createApp } from "vue";
import store from "./store";
import router from "@/router";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./custom.css";

const app = createApp(App);

app.use(router);
app.use(store);
app.mount("#app");

import "bootstrap/dist/js/bootstrap.js";
